import { render, staticRenderFns } from "./ShoppingListAddButton.vue?vue&type=template&id=a6c0ffba"
import script from "./ShoppingListAddButton.vue?vue&type=script&lang=js"
export * from "./ShoppingListAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports